export default __webpack_public_path__ + "static/media/animation-arrow11.8e2ecb2b.gif";